import { useMountEffect } from "@opensea/ui-kit/hooks";
import { chunk } from "es-toolkit/compat";
import { useState } from "react";
import { uploadFile } from "@/lib/upload";
import { UploadProgress } from "@/lib/upload/progress";
export function useFileUpload({
  chunkSize = 50,
  setState,
  getContext
}) {
  const [isUploading, setIsUploading] = useState(false);
  const [controller, setController] = useState();
  const [fileTotalSizes, setFileTotalSizes] = useState(0);
  const [totalFiles, setTotalFiles] = useState(0);
  const [uploadedFiles, setUploadedFiles] = useState(0);
  const [progresses, setProgresses] = useState({});
  const upload = async file => {
    if (isUploading) {
      return;
    }
    const files = Array.isArray(file) ? file : [file];
    if (files.length <= 0) {
      return;
    }
    const totalFilesSize = files.reduce((prev, current) => prev + current.size, 0);
    const controller_0 = new AbortController();
    setIsUploading(true);
    setController(controller_0);
    setProgresses({});
    setFileTotalSizes(totalFilesSize);
    setState?.("uploading");
    setTotalFiles(files.length);
    const mediaTokens = [];
    try {
      for (const fileChunk of chunk(files, chunkSize)) {
        const uploadContexts = await getContext(fileChunk);
        await Promise.all(fileChunk.map((file_0, i) => {
          const context = uploadContexts[i];
          mediaTokens.push(context.token);
          return uploadFile(context, file_0, progress => setProgresses(prev_0 => ({
            ...prev_0,
            [file_0.name]: progress
          })), controller_0).then(() => {
            setUploadedFiles(prev_1 => prev_1 + 1);
          });
        }));
      }
      setState?.("upload-success");
      return mediaTokens;
    } catch (err) {
      setState?.("upload-error");
      throw err;
    } finally {
      setIsUploading(false);
      setController(undefined);
    }
  };
  useMountEffect(() => {
    return () => {
      controller?.abort();
    };
  });
  const progress_0 = getTotalProgress(progresses, fileTotalSizes);
  const fileProgress = {
    total: totalFiles,
    uploaded: uploadedFiles
  };
  return {
    isUploading,
    progress: progress_0,
    fileProgress,
    upload
  };
}
const getTotalProgress = (progresses, fileTotalSizes) => {
  let writtenBytes = 0;
  let totalBytes = 0;
  for (const progress of Object.values(progresses)) {
    writtenBytes += progress.bytesWritten;
    totalBytes += progress.totalBytes;
  }
  return new UploadProgress(writtenBytes, Math.max(fileTotalSizes, totalBytes));
};